import React from 'react';
import axios from 'axios';
import { useWorkspace } from '../../../context/WorkspaceContext';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const RedditLoginButton = () => {
    const { activeWorkspace, idToken } = useWorkspace();

    const handleAuthClick = () => {
        if (!activeWorkspace || !idToken) {
            console.error('No active workspace or token');
            return;
        }

        // Set flag to indicate auth is pending
        localStorage.setItem('social_auth_pending', 'reddit');

        // Start Reddit OAuth flow with workspaceId as query parameter
        axios.get(`${BACKEND_API_URL}/api/reddit/oauth`, {
            headers: { Authorization: `Bearer ${idToken}` },
            params: { workspaceId: activeWorkspace.id }
        }).then(response => {
            // Open Reddit auth URL in new window
            window.open(response.data, '_blank');
        }).catch(error => {
            console.error('Reddit OAuth error:', error);
            localStorage.removeItem('social_auth_pending');
        });
    };

    return (
        <button
            onClick={handleAuthClick}
            className="h-[70px] p-4 rounded-lg flex items-center w-full justify-between text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
        >
            <div className="mr-3 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <img
                    src={`${process.env.PUBLIC_URL}/socials/reddit-logo.svg`}
                    alt="Reddit Logo"
                    className="w-8 h-8"
                />
            </div>
            <p className="text-white font-bold">Reddit</p>
            <div></div>
        </button>
    );
};

export default RedditLoginButton; 